<div
  id="eventCalenderViewFront"
  [style]="
    'background-image:url(' +
    (event.extendedProps.eventImage
      ? event.extendedProps.eventImage
      : 'https://asylumtixmedia.sfo3.digitaloceanspaces.com/2024-08-28T23%3A27%3A36.627Zno-image-event.png') +
    ');background-size:cover'
  "
  class="cursor-pointer absolute p-0 top-0 max-h-[11rem] origin left-0 flex h-full flex-col gap-2 break-words bg-[#001E30] text-white w-full hover:scale-150"
  [class.origin-bottom]="OriginBottom(event.extendedProps.rawDate)"
  [class.origin-bottom-right]="OriginBottomRight(event.extendedProps.rawDate)"
  [class.origin-bottom-left]="OriginBottomLeft(event.extendedProps.rawDate)"
  [class.origin-top-right]="
    OriginTopRight(event.extendedProps.rawDate) &&
    !OriginBottomRight(event.extendedProps.rawDate)
  "
  [class.origin-top]="
    OriginTop(event.extendedProps.rawDate) &&
    !OriginBottom(event.extendedProps.rawDate)
  "
  [class.origin-top-left]="
    OriginTopLeft(event.extendedProps.rawDate) &&
    !OriginBottomLeft(event.extendedProps.rawDate)
  "
  (click)="
    isShowSoldOut
      ? null
      : openPurchasingPortal(event.extendedProps.eventInstanceId)
  "
>
  <img
    *ngIf="isShowSoldOut"
    class="z-[100] absolute top-0 left-0 h-full max-h-[11rem] w-full"
    src="https://asylumtixmedia.sfo3.digitaloceanspaces.com/2024-09-19T13%3A41%3A31.397Zsold-out.png"
  />
  <div
    class="absolute w-full h-full top-0 max-h-[11rem] left-0 p-0 flex flex-col justify-end items-start tooltip-container"
  >
    <div
      class="container bg-gradient-to-b p-2 pt-12 from-transparent via-[rgba(0,0,0,0.4)] to-[rgba(0,0,0,6)]"
    >
      <h1
        class="title font-bold break-normal whitespace-pre-wrap text-sm line-clamp-3"
      >
        {{ event.title }}
      </h1>

      <div
        class="text-white title flex gap-x-1 items-center mb-1 max-w-full flex-wrap"
      >
        <span class="title">{{ event.extendedProps.startTime }}</span>
        <span class="title w-1 h-1 rounded-full bg-[#DDE3EA]"></span>
        <span class="title">from {{ event.extendedProps.minTicketPrice }}</span>
      </div>
      <a
        *ngIf="!isShowSoldOut"
        class="px-2 text-white w-fit no-underline pb-[0.5px] pt-[1px] gap-2 flex items-center border border-white"
        [routerLink]="['/venue', this.venueId]"
        [queryParams]="{
          searchEvent: event.extendedProps.eventInstanceId,
          open: event.extendedProps.eventInstanceId,
          selectedEvent: event.extendedProps.eventInstanceId
        }"
        target="_blank"
      >
        <div class="font-semibold">GET TICKETS</div>
        <tix-icon svgIcon="arrow-right-solid" class="!h-4 !w-4"></tix-icon>
      </a>
    </div>
  </div>

  <p class="hidden">{{ event.start }}</p>
  <div class="hidden">
    <tix-events-list
      #EventItemCard
      [event]="event.extendedProps.portalEvent"
      [venueDetail]="venueDetails$ | async"
      [venueId]="venueId"
    ></tix-events-list>
  </div>
</div>
<!-- 


-->
